module.exports = __webpack_public_path__ + "static/img/Jarrod_Witts_mobile.56eddd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jarrod_Witts_mobile.jpg
// module id = swLW
// module chunks = 0